<template>
  <div class="bindingLogin">
    <div>
      <div class="login-loading">
        <div class="loader-inner ball-scale-multiple">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p>正在跳转请稍后...</p>
    </div>
  </div>
</template>

<script>
import { getCookie, removeCookie } from "@/utils/cookie";

export default {
  name: 'bindingLogin',
  data () {
    return {}
  },
  methods: {
    openid () {
      const formName = getCookie('formName')
      let urlNow = formName === 'transfer' ? encodeURIComponent(window.location.href.split('#')[0] + '#/rent') : encodeURIComponent(window.location.href.split('#')[0])
      let scope = 'snsapi_userinfo'
      let appid = process.env.VUE_APP_BASE_APPID
      let state = ''
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
      window.location.replace(url)
      removeCookie('formName')
    }
  },
  mounted () {
    if(process.env.NODE_ENV !== 'production') {
      this.$store.dispatch('GetInfo').then(res => {
        this.$router.replace({name: '/'})
      })
    } else {
      this.openid()
    }
  },
  created () {},
  components: {}
}
</script>

<style scoped lang='less'>
.bindingLogin{
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #fff !important;
  padding: .3rem;
  >div{
    width: 150px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .login-loading{
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }
    p{
      line-height: 1rem;
      font-size: .28rem;
      color: #409EFF;
    }
  }
}
</style>
